import {NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";

import {CustomAlertComponent} from './custom-alert.component';
import {CustomAlertService} from "./custom-alert.service";

@NgModule({
    imports: [CommonModule],
    exports: [CustomAlertComponent],
    declarations: [CustomAlertComponent],
    providers: [CustomAlertService],
})
export class CustomAlertModule {
}
